import React from 'react';

function ContactUs() {
  const emailUser = "contact";
  const emailDomain = "pixelcreator.co.uk";
  const email = `${emailUser}@${emailDomain}`;

  const phoneDisplay = "07897 920710";
  const phoneDigits = "+447897920710";

  const handleEmailClick = () => {
    window.location.href = `mailto:${email}`;
  };

  const handlePhoneClick = () => {
    window.location.href = `tel:${phoneDigits}`;
  };

  const linkStyle = {
    background: 'none',
    border: 'none',
    color: '#FFF9DB',
    cursor: 'pointer',
    fontSize: '1.2rem'
  };

  return (
    <div style={{ backgroundColor: '#3b3b3b', minHeight: '100vh' }}>
      <div
        style={{
          padding: '1rem',
          color: '#FFF9DB',
          textAlign: 'center'
        }}
      >
        <h1>Contact Us</h1>
        <br />

        <h2><u>E-mail</u></h2>
        <h3>
          <button onClick={handleEmailClick} style={linkStyle}>
            {email}
          </button>
        </h3>

        <br />

        <h2><u>Telephone</u></h2>
        <h3>
          <button onClick={handlePhoneClick} style={linkStyle}>
            {phoneDisplay}
          </button>
        </h3>
      </div>
    </div>
  );
}

export default ContactUs;


